export const clearWhitespace = (text = '', trim = false) => {
  let cleaned = text
    .replace(/(\r)|(\n)|(\t)/g, ' ') // remove tabs and new lines
    .replace(/(\s+)/g, ' '); // convert multiple spaces to a single space
  if (trim) {
    cleaned = cleaned.replace(/(^\s+)|(\s+$)/g, '');
  }
  return cleaned;
};

export const clearLineBreaks = (text = '') =>
  text.replace(/(\r\n|\n|\r)+/gm, ' ');
